import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export function generateStockStatusPdf(rows, dateStr, dsName, distributorName) {
    const doc = new jsPDF({
        unit: "mm",
        format: [80, 200], // 80mm width for mobile/thermal printers
    });

    const width = 80;
    let y = 10;

    // Header
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text((distributorName || "QUICKBILL").toUpperCase(), width / 2, y, { align: "center" });
    y += 6;

    doc.setFontSize(10);
    doc.text("STOCK STATUS REPORT", width / 2, y, { align: "center" });
    y += 6;

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Date: ${dateStr}`, 5, y);
    y += 4;
    doc.text(`DS: ${dsName}`, 5, y);
    y += 6;

    doc.setLineWidth(0.2);
    doc.line(5, y, width - 5, y);
    y += 5;

    // Table
    const tableData = rows.map(r => [
        r.name,
        r.opening.toString(),
        r.billed.toString(),
        r.sold.toString(),
        r.closing.toString()
    ]);

    // Add totals row
    const totals = {
        opening: rows.reduce((a, b) => a + b.opening, 0),
        billed: rows.reduce((a, b) => a + b.billed, 0),
        sold: rows.reduce((a, b) => a + b.sold, 0),
        closing: rows.reduce((a, b) => a + b.closing, 0)
    };
    tableData.push([
        "TOTAL",
        totals.opening.toString(),
        totals.billed.toString(),
        totals.sold.toString(),
        totals.closing.toString()
    ]);

    autoTable(doc, {
        startY: y,
        head: [['SKU', 'Op', 'Rec', 'Sal', 'Cl']],
        body: tableData,
        theme: 'plain',
        styles: { fontSize: 7, cellPadding: 1 },
        headStyles: { fontStyle: 'bold', fillColor: [240, 240, 240] },
        columnStyles: {
            0: { cellWidth: 30 }, // SKU Name
            1: { halign: 'center' }, // Op
            2: { halign: 'center' }, // Rec (Receipt)
            3: { halign: 'center' }, // Sal (Sales)
            4: { halign: 'center', fontStyle: 'bold' }  // Cl
        },
        margin: { left: 5, right: 5 },
        didParseCell: function(data) {
            if (data.row.index === tableData.length - 1) {
                data.cell.styles.fontStyle = 'bold';
            }
        }
    });

    y = (doc.lastAutoTable?.finalY || y) + 10;

    doc.setFontSize(6);
    doc.setFont("helvetica", "italic");
    doc.text("Powered by Quickbill", width / 2, y, { align: "center" });

    return doc;
}
